(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allstock-comparator"] && !Shopify.designMode) return;
  try {
    
/* AllStock comparison parser. No network, prices, HTML output, or catalogue mutations.
 * Browser: AllStockSpecParser.parseComparisonSpecs(product, variant)
 * Node: require('./spec-parser.js').parseComparisonSpecs(product, variant)
 * Missing and ambiguous values deliberately remain 'No especificado'.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.AllStockSpecParser = api; root.parseComparisonSpecs = api.parseComparisonSpecs; }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var MISSING = 'No especificado';
  var SCHEMA = [
    ['screen', 'Pantalla', [['display', 'Pantalla']]],
    ['performance', 'Rendimiento', [['processor', 'Procesador'], ['operating_system', 'Sistema operativo'], ['expandable_storage', 'Memoria expandible']]],
    ['cameras', 'Cámaras', [['rear_camera', 'Cámara trasera'], ['front_camera', 'Cámara frontal'], ['video', 'Grabación de video']]],
    ['battery', 'Batería', [['battery_capacity', 'Capacidad de batería'], ['charging', 'Carga'], ['wireless_charging', 'Carga inalámbrica'], ['autonomy', 'Autonomía declarada']]],
    ['connectivity', 'Conectividad', [['mobile_network', 'Red móvil'], ['connections', 'Conectividad'], ['sim', 'SIM']]],
    ['design', 'Diseño', [['design_description', 'Diseño'], ['resistance', 'Resistencia y protección'], ['security', 'Seguridad'], ['materials', 'Materiales'], ['dimensions', 'Dimensiones'], ['weight', 'Peso']]]
  ];
  function clean(value) { return String(value == null ? '' : value).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); }
  function norm(value) { return clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
  function label(value) { return norm(value).replace(/[^a-z0-9 +/]/g, '').trim(); }
  function unique(values) { return Array.from(new Set(values.filter(Boolean))); }
  function warn(list, code, field, message) {
    if (!list.some(function (w) { return w.code === code && w.field === field; })) list.push({code: code, field: field, message: message});
  }
  function decode(text) {
    var entities = {amp:'&',lt:'<',gt:'>',quot:'"',apos:"'",nbsp:' ',aacute:'á',eacute:'é',iacute:'í',oacute:'ó',uacute:'ú',ntilde:'ñ',uuml:'ü',Aacute:'Á',Eacute:'É',Iacute:'Í',Oacute:'Ó',Uacute:'Ú',Ntilde:'Ñ',times:'×',middot:'·',ndash:'–',mdash:'—',rdquo:'”',ldquo:'“',rsquo:'’',lsquo:'‘',deg:'°'};
    return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, function (all, entity) {
      if (entity[0] === '#') {
        var n = parseInt(entity.slice(entity[1].toLowerCase() === 'x' ? 2 : 1), entity[1].toLowerCase() === 'x' ? 16 : 10);
        return n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : '';
      }
      return Object.prototype.hasOwnProperty.call(entities, entity) ? entities[entity] : all;
    });
  }
  function makeNode(tag, attrs, parent) { return {tag:tag, attrs:attrs || {}, parent:parent || null, children:[]}; }
  function htmlTree(html) {
    // Strip resource-bearing/inert content before DOMParser so parsing cannot fetch it.
    html = String(html || '').replace(/<(script|style|iframe|object|template)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, '').replace(/<(?:img|link|source|video|audio|embed|iframe|object)\b[^>]*>/gi, '');
    if (typeof DOMParser !== 'undefined') {
      var dom = new DOMParser().parseFromString(html, 'text/html');
      function convert(node, parent) {
        if (node.nodeType === 3) return {tag:'#text', value:node.nodeValue || '', parent:parent};
        var out = makeNode((node.tagName || 'root').toLowerCase(), {}, parent);
        Array.from(node.attributes || []).forEach(function (a) { out.attrs[a.name.toLowerCase()] = a.value; });
        Array.from(node.childNodes || []).forEach(function (c) { if (c.nodeType === 1 || c.nodeType === 3) out.children.push(convert(c, out)); });
        return out;
      }
      return convert(dom.body, null);
    }
    // Dependency-free server/test fallback for the catalogue's HTML fragments.
    // It is not a browser HTML repair engine; browser DOMParser remains preferred.
    var tree = makeNode('root'), stack = [tree], token;
    var tokens = /<!--[\s\S]*?-->|<![^>]*>|<\/?[a-zA-Z][^>]*>|[^<]+/g;
    while ((token = tokens.exec(html))) {
      var s = token[0], parent = stack[stack.length - 1];
      if (/^<!/.test(s)) continue;
      if (/^<\//.test(s)) {
        var closing = s.match(/^<\/\s*([\w-]+)/)[1].toLowerCase();
        for (var i = stack.length - 1; i > 0; i--) { if (stack[i].tag === closing) { stack.length = i; break; } }
      } else if (s[0] === '<') {
        var opening = s.match(/^<([\w-]+)/), tag = opening[1].toLowerCase(), attrs = {}, match;
        var ar = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/g;
        while ((match = ar.exec(s))) attrs[match[1].toLowerCase()] = decode(match[2] || match[3] || match[4] || '');
        var n = makeNode(tag, attrs, parent); parent.children.push(n);
        if (!/\/$/.test(s.slice(0,-1)) && !/^(br|hr|input|meta|wbr|area|base|col|param)$/.test(tag)) stack.push(n);
      } else parent.children.push({tag:'#text', value:decode(s), parent:parent});
    }
    return tree;
  }
  function text(node) { return node.tag === '#text' ? node.value : node.tag === 'br' ? ' ' : (node.children || []).map(text).join(' '); }
  function elements(node) { return (node.children || []).filter(function (c) { return c.tag !== '#text'; }); }
  function walk(node, fn) { fn(node); (node.children || []).forEach(function (c) { walk(c, fn); }); }
  function promotion(node) {
    for (var p = node; p; p = p.parent) {
      if (p.attrs && Object.keys(p.attrs).some(function (k) { return k.indexOf('data-allstock-oferta') === 0; })) return true;
      if (elements(p).some(function (c) { return /^h[1-6]$/.test(c.tag) && /promocion|incluye con tu compra|regalos|financiacion|^precio$/.test(norm(text(c))); })) return true;
    }
    return false;
  }
  function collect(tree) {
    var rows = [], gifts = [], seen = new Set();
    function add(key, value, kind, promo) {
      key = clean(key).replace(/[:：]\s*$/, ''); value = clean(value).replace(/^[:：]\s*/, '');
      if (!key || !value) return;
      var signature = key + '\u0000' + value + '\u0000' + promo;
      if (seen.has(signature)) return; seen.add(signature);
      (promo ? gifts : rows).push({label:key,value:value,priority:kind === 'card' ? 1 : 3});
    }
    walk(tree, function (n) {
      var es = elements(n), isPromo = promotion(n);
      if (n.tag === 'tr') {
        var cells = es.filter(function (e) { return e.tag === 'th' || e.tag === 'td'; });
        if (cells.length >= 2) add(text(cells[0]), cells.slice(1).map(text).join(' '), 'row', isPromo);
      }
      if (/^(p|li)$/.test(n.tag)) {
        var first = es[0], all = clean(text(n));
        if (first && /^(span|strong|b)$/.test(first.tag)) {
          var firstText = clean(text(first)), rest = clean(all.slice(firstText.length));
          if (all.indexOf(firstText) === 0 && rest) add(firstText, rest, 'row', isPromo);
        } else {
          var colon = all.indexOf(':');
          if (colon > 0 && colon < 160) add(all.slice(0,colon), all.slice(colon+1), 'row', isPromo);
          else if (isPromo && /cargador|estuche|audifon|airpods|parlante|mica|magsafe/.test(norm(all))) add('Promoción general', all, 'row', true);
        }
      }
      if (n.tag === 'h4' || n.tag === 'h3') {
        var peers = elements(n.parent || n), ps = peers.filter(function (e) { return e.tag === 'p'; });
        if (peers.filter(function (e) { return /^h[1-6]$/.test(e.tag); }).length === 1 && ps.length === 1) add(text(n), text(ps[0]), 'card', isPromo);
      }
      if (n.tag === 'dt' && n.parent) {
        var siblings = elements(n.parent), next = siblings[siblings.indexOf(n) + 1];
        if (next && next.tag === 'dd') add(text(n), text(next), 'row', isPromo);
      }
    });
    return {rows:rows,gifts:gifts};
  }
  function optionPairs(product, variant) {
    if (Array.isArray(variant.selectedOptions) && variant.selectedOptions.length) return variant.selectedOptions.map(function (o) { return {name:clean(o.name),value:clean(o.value)}; });
    var defs = Array.isArray(product.options) ? product.options : [], values = Array.isArray(variant.options) ? variant.options : [];
    if (values.length && typeof values[0] === 'object') return values.map(function (o) { return {name:clean(o.name),value:clean(o.value)}; });
    return defs.map(function (o, i) { var position = typeof o === 'object' && o.position ? o.position - 1 : i; return {name:typeof o === 'object' ? o.name : o,value:clean(values[position] == null ? variant['option' + (position+1)] : values[position])}; });
  }
  function capacityTokens(value) {
    return Array.from(String(value).matchAll(/\b(\d+(?:[.,]\d+)?)\s*(TB|GB)\b/gi)).filter(function (m) { return m[2].toUpperCase() === 'TB' || Number(m[1]) >= 32; }).map(function (m) { return {value:m[1].replace(',','.') + ' ' + m[2].toUpperCase(),index:m.index,length:m[0].length}; });
  }
  function ramFromOption(value, storage) {
    var caps = capacityTokens(value), raw = clean(value);
    if (storage && caps.length) raw = clean(raw.slice(0,caps[caps.length-1].index)).replace(/[\s/|·:+-]+$/, '');
    if (!/\d\s*(?:\+\s*\d+\s*)?(?:GB|RAM)\b/i.test(raw)) return '';
    return raw.replace(/\bRAM\b/gi, '').replace(/\s+/g, ' ').trim();
  }
  function configuration(pairs, rows, warnings) {
    var result = {storage:MISSING,ram:MISSING,color:MISSING,gift:MISSING}, storage = [], ram = [], colors = [];
    pairs.forEach(function (o) {
      var key = label(o.name);
      if (/^(color|colour|colores)$/.test(key) && o.value) colors.push(o.value);
      if (!/ram|almacenamiento|capacidad|memoria|storage/.test(key)) return;
      var caps = capacityTokens(o.value);
      caps.forEach(function (c) { storage.push(c.value); });
      var rv = ramFromOption(o.value, caps.length > 0);
      if (rv) ram.push(rv);
    });
    [['storage',storage],['ram',ram],['color',colors]].forEach(function (item) {
      var u = unique(item[1]); if (u.length === 1) result[item[0]] = u[0];
      else if (u.length > 1) warn(warnings,'ambiguous_configuration',item[0],'Las opciones seleccionadas contienen valores diferentes.');
    });
    var memory = rows.filter(function (r) { return /^(memoria|memoria ram|version de memoria|versiones de memoria|almacenamiento|capacidades en allstock)$/.test(label(r.label)); });
    if (result.storage === MISSING && storage.length === 0) {
      var bodyCaps = unique(memory.flatMap(function (r) { return capacityTokens(r.value).map(function (c) { return c.value; }); }));
      if (bodyCaps.length === 1) result.storage = bodyCaps[0];
      else if (bodyCaps.length > 1) warn(warnings,'variant_required','storage','La ficha declara varias capacidades; se necesita una variante inequívoca.');
    }
    // Body RAM is only a fallback, never a replacement for an explicit variant option.
    if (result.ram === MISSING && ram.length === 0) {
      var candidates = [];
      memory.forEach(function (r) {
        var candidatesText = r.value.split(/;|\.(?=\s+[A-ZÁÉÍÓÚ])/).map(clean);
        candidatesText.forEach(function (part) {
          var caps = unique(capacityTokens(part).map(function (c) { return c.value; }));
          if (caps.length > 1 || (caps.length === 1 && result.storage !== MISSING && caps[0] !== result.storage)) return;
          // Do not select from alternatives or from a global options explanation.
          if (/\bopciones\b|\bversiones\b|\bo\s+\d|\by\s+\d/.test(norm(part))) return;
          var rv = part.match(/\d+\s*(?:\+\s*\d+\s*)?GB\s*(?:(?:de\s+)?RAM\b|fisic[ao]s?\b)[\s\S]*$/i);
          if (!rv) return;
          var candidate = rv[0].replace(/\s*[/|·]\s*\d+\s*(?:GB|TB)[\s\S]*$/i,'').replace(/\s*(?:de almacenamiento|de RAM)\s*$/i,'');
          if (capacityTokens(candidate).length || /(?:no equivale|utiliza|disponibilidad depende)/i.test(candidate)) return;
          candidates.push(clean(candidate).replace(/[.;]+$/,''));
        });
      });
      var uniqueRam = unique(candidates);
      if (uniqueRam.length === 1) result.ram = uniqueRam[0];
      else if (uniqueRam.length > 1) warn(warnings,'ambiguous_configuration','ram','La descripción no permite asignar una sola RAM a la variante.');
    }
    return result;
  }
  function simType(value) {
    var t = norm(value), esim = /e[ -]?sim/.test(t), physical = /\bchip\b|sim fisic|nano[ -]?sim/.test(t);
    return esim && physical ? 'SIM física + eSIM' : esim ? 'eSIM' : physical ? 'SIM física' : '';
  }
  function giftFor(pairs, promos, config, warnings) {
    var packageName = clean((pairs.find(function (o) { return /paquete|package|regalo|promocion/.test(label(o.name)); }) || {}).value);
    // These are literal package names selected by the customer, not inferred gifts.
    if (packageName && /cargador|estuche|audifon|airpods|parlante|mica|magsafe/.test(norm(packageName))) return packageName;
    var sim = simType(pairs.map(function (o) { return o.value; }).join(' '));
    var candidates = [];
    promos.forEach(function (r) {
      if (!/cargador|estuche|audifon|airpods|parlante|mica|magsafe/.test(norm(r.value))) return;
      var general = /promocion|incluye con tu compra/.test(norm(r.label));
      var criterion = (general ? r.value : r.label).replace(/\$\s*[\d.,]+/g,''), capacities = unique(capacityTokens(criterion).map(function (c) { return c.value; }));
      if (!capacities.length) {
        // A literal product-wide inclusion may apply to all variants; conditional prose may not.
        if (!general || /\$|\b(?:version|capacidad|paquete|seleccion|segun|solo|si|color|desde)\b/.test(norm(r.value))) return;
      } else if (config.storage === MISSING || capacities.indexOf(config.storage) < 0) return;
      if (/paquete/i.test(criterion)) {
        var required = norm(criterion.split(/paquete/i)[1] || '').replace(/[():]/g,'').trim();
        if (!packageName || !norm(packageName).includes(required)) return;
      }
      var requiredSim = simType(criterion);
      if (requiredSim && requiredSim !== sim && requiredSim !== 'SIM física + eSIM') return;
      // For per-color offers only literal color names or ordinary translations match.
      var colorWords = norm(criterion).match(/\b(naranja|azul|blanco|negro|silver|orange|blue|black|white|burgundy|vino)\b/g);
      if (colorWords) {
        var translations = {orange:'naranja',blue:'azul',black:'negro',white:'blanco',burgundy:'vino'};
        var chosen = norm(config.color).split(/\s+/).map(function (c) { return translations[c] || c; });
        if (!colorWords.some(function (c) { return chosen.indexOf(translations[c] || c) >= 0; })) return;
      }
      // RAM-qualified offers must match the explicit RAM instead of just the storage.
      var ramCriterion = general ? '' : ramFromOption(criterion, true);
      if (ramCriterion) {
        if (config.ram === MISSING) return;
        var wanted = (ramCriterion.match(/\d+/g) || []).join('+'), actual = (config.ram.match(/\d+/g) || []).join('+');
        if (wanted && actual && wanted !== actual && !actual.startsWith(wanted + '+')) return;
      }
      if (!/\$/.test(r.value)) candidates.push(clean(r.value).replace(/[.;]+$/,''));
    });
    var u = unique(candidates);
    if (u.length === 1) return u[0];
    if (u.length > 1) warn(warnings,'ambiguous_gift','gift','Hay promociones diferentes para esta configuración y no se identificó un paquete exacto.');
    else if (promos.some(function (r) { return /cargador|estuche|audifon|airpods|parlante|mica|magsafe/.test(norm(r.value)); })) warn(warnings,'gift_not_matched','gift','No se asignó un regalo: las condiciones de la promoción no coinciden inequívocamente con la variante.');
    return MISSING;
  }
  function parseComparisonSpecs(product, variant) {
    product = product || {}; variant = variant || {};
    var warnings = [], extracted = collect(htmlTree(product.descriptionHtml || product.description || product.body_html || ''));
    var pairs = optionPairs(product,variant), config = configuration(pairs,extracted.rows,warnings), values = {};
    function put(key, value, priority) {
      value = clean(value).replace(/^[\s·;,+]+|[\s·;,]+$/g,'');
      if (!value || /\$|\b(?:cuotas|meses de gracia|precio|gratis|regalo|promocion|selecciona el paquete)\b/i.test(norm(value))) return;
      var current = values[key];
      if (!current || priority > current.priority) values[key] = {value:value,priority:priority};
      else if (priority === current.priority && norm(current.value) !== norm(value)) {
        if (norm(value).includes(norm(current.value))) values[key] = {value:value,priority:priority};
        else if (!norm(current.value).includes(norm(value))) {
          values[key] = {value:MISSING,priority:priority};
          warn(warnings,'conflicting_spec',key,'Hay valores distintos con la misma prioridad en la descripción.');
        }
      }
    }
    function cameras(value, priority) {
      var front = norm(value).search(/(?:camara\s+)?(?:frontal|selfie)\b/);
      if (front >= 0) {
        var rear = value.slice(0,front).replace(/(?:[.;·+]\s*|y\s*)$/,'').trim();
        if (rear) put('rear_camera',rear,priority);
        put('front_camera',value.slice(front).replace(/^(?:c[aá]mara\s+)?(?:frontal|selfie)(?:\s+de)?\s*/i,''),priority);
      } else put('rear_camera',value,priority);
    }
    function battery(value, priority) {
      var capacity = value.match(/\b\d[\d.,\s]*\s*mAh\b/i);
      if (capacity) put('battery_capacity',capacity[0],priority);
      var weight = value.match(/\bpeso(?: de)?\s+(\d+(?:[.,]\d+)?\s*g)\b/i);
      if (weight) put('weight',weight[1],priority);
      var rest = clean(value.replace(/\b\d[\d.,\s]*\s*mAh\b/i,'').replace(/(?:\s*[;·,]|\s+y)?\s*peso(?: de)?\s+\d+(?:[.,]\d+)?\s*g[. ]*$/i,'').replace(/^[\s·,+;]+/,''));
      if (/carga|\d\s*w\b|magsafe|qi2?|supercharge|hypercharge|turbopower|usb[ -]?c/i.test(rest)) put('charging',rest,priority);
      else if (/\d\s*(?:h|horas)\b/i.test(rest)) put('autonomy',rest,priority);
    }
    extracted.rows.forEach(function (r) {
      var k = label(r.label), v = r.value, n = norm(v), rank = r.priority;
      if (/^(pantallas?|display)$/.test(k)) put('display',v,rank);
      else if (/^(procesador|chipset|chip|rendimiento)$/.test(k)) put('processor',v,rank);
      else if (/^(sistema|sistema operativo)$/.test(k)) put('operating_system',v,rank);
      else if (/^(micro ?sd|memoria expandible)$/.test(k)) put('expandable_storage',v,rank);
      else if (/^camara (frontal|selfie)$/.test(k)) put('front_camera',v,rank);
      else if (/^camaras? (traseras?|principal)$/.test(k)) put('rear_camera',v,rank);
      else if (/^(camaras?|sistema de camaras)$/.test(k)) cameras(v,rank);
      else if (/^(grabacion de video|video)$/.test(k)) put('video',v,rank);
      else if (/^bateria(?: y (?:carga|diseno))?$/.test(k)) battery(v,rank);
      else if (/^carga inalambrica$/.test(k)) put('wireless_charging',v,rank);
      else if (/^(carga|carga rapida)$/.test(k)) put('charging',v,rank);
      else if (/^(autonomia|duracion de bateria)$/.test(k)) put('autonomy',v,rank);
      else if (/^(red movil|conectividad movil)$/.test(k)) put('mobile_network',v,rank);
      else if (/^conectividad$/.test(k)) {
        put('connections',v,rank);
        var network = v.match(/\b[345]\s*G(?:\s*LTE)?\b/gi);
        if (network) put('mobile_network',unique(network).join(' / '),rank);
      }
      else if (/^(resistencia|proteccion)$/.test(k)) put('resistance',v,rank);
      else if (/^seguridad$/.test(k)) put('security',v,rank);
      else if (/^(construccion|acabado|materiales)$/.test(k)) put('materials',v,rank);
      else if (/^(dimensiones|diseno)$/.test(k) && /\d.+(?:mm|cm|×| x )/i.test(v)) { put('dimensions',v.replace(/[;·,]\s*\d+(?:[.,]\d+)?\s*g\b.*$/i,''),rank); var weight = v.match(/\b\d+(?:[.,]\d+)?\s*g\b/); if (weight) put('weight',weight[0],rank); }
      else if (k === 'diseno') put('design_description',v,rank);
      else if (k === 'peso') put('weight',v,rank);
      else if (r.priority === 1) {
        // Highlight cards are fallback evidence only, never guessed from product names.
        var combined = clean(r.label + ' · ' + v);
        if (/amoled|oled|retina|\blcd\b|pulgadas|\bips\b|\b\d+\s*hz\b/.test(k) && /pantalla|amoled|oled|retina|lcd|ips|\d[.,]\d["″]/i.test(combined)) put('display',combined,1);
        else if (/^(?:chip )?a\d+|snapdragon|dimensity|exynos|helio|unisoc/.test(k)) put('processor',r.label,1);
        else if (/\d\s*mah\b/.test(k)) battery(combined,1);
        else if (/\d\s*w\b|carga/.test(k) && !/camara|camaras/.test(k)) put('charging',combined,1);
        else if (/\bip\d{2}\b/.test(k)) put('resistance',combined,1);
        else if (/face id|huella/.test(k)) put('security',combined,1);
        else if (/^(aluminio|titanio|cuero|ceramic shield)/.test(k)) put('materials',combined,1);
        else if (/bateria/.test(k) && /\d\s*(?:h|horas)\b/.test(n)) put('autonomy',v,1);
      }
    });
    var selectedSim = unique(pairs.map(function (o) { return simType(o.value); }).filter(Boolean));
    if (selectedSim.length === 1) put('sim',selectedSim[0],5);
    var titleNetwork = (product.title || '').match(/\b([345])\s*G\b/i), bodyNetwork = values.mobile_network && values.mobile_network.value;
    if (titleNetwork && bodyNetwork && bodyNetwork !== MISSING && !new RegExp('\\b' + titleNetwork[1] + '\\s*G\\b','i').test(bodyNetwork)) {
      values.mobile_network = {value:MISSING,priority:10};
      warn(warnings,'title_network_conflict','mobile_network','El título y la descripción declaran redes móviles distintas.');
    }
    config.gift = giftFor(pairs,extracted.gifts,config,warnings);
    if (!extracted.rows.length) warn(warnings,'no_structured_specs','groups','No se reconocieron características técnicas etiquetadas en la descripción.');
    return {
      configuration:config,
      groups:SCHEMA.map(function (group) { return {id:group[0],label:group[1],rows:group[2].map(function (row) { return {key:row[0],label:row[1],value:values[row[0]] ? values[row[0]].value : MISSING}; })}; }),
      warnings:warnings
    };
  }
  return {parseComparisonSpecs:parseComparisonSpecs,missingValue:MISSING};
});

(() => {
  class AllstockComparator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.text = JSON.parse(this.querySelector('[data-ac-text]').textContent);
      this.overrides = JSON.parse(this.querySelector('[data-ac-overrides]')?.textContent || '{"products":{}}');
      this.catalog = new Map();
      this.slots = [];
      this.stamp = 0;
      this.rootPath = `${(this.dataset.root || '/').replace(/\/$/, '')}/`;
      this.container = this.querySelector('.ac-slots');
      this.results = this.querySelector('.ac-results');
      this.notice = this.querySelector('.ac-notice');
      this.shareInput = this.querySelector('.ac-share-link');
      this.addButton = this.querySelector('[data-add]');
      this.diffInput = this.querySelector('[data-differences]');
      this.addButton.disabled = true;
      this.querySelector('[data-example]').disabled = true;
      this.addButton.addEventListener('click', () => { if (!this.initialized) return; this.addSlot(); this.sync(); });
      this.diffInput.addEventListener('change', () => this.renderResults());
      this.querySelectorAll('[data-copy]').forEach(button=>button.addEventListener('click', () => this.copy()));
      this.querySelector('[data-refresh]').addEventListener('click', () => this.refresh());
      this.querySelector('[data-example]').addEventListener('click', () => this.example());
      this.onVisible = () => { if (document.visibilityState === 'visible' && Date.now() - this.stamp > 60000) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisible);
      this.bootstrap();
    }
    disconnectedCallback() { document.removeEventListener('visibilitychange', this.onVisible); }
    el(tag, cls, text) {
      const element = document.createElement(tag);
      if (cls) element.className = cls;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    t(key) { return this.text[key] || this.text.unspecified; }
    name(product) {
      const title = product.title || '';
      return title.toLowerCase().includes((product.vendor || '').toLowerCase()) ? title : `${product.vendor || ''} ${title}`.trim();
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'es-EC', {style: 'currency', currency: this.dataset.currency || 'USD'}).format(cents / 100);
    }
    readCatalog(fragment) {
      fragment.querySelectorAll('[data-ac-product]').forEach(item => this.catalog.set(item.dataset.handle, {handle:item.dataset.handle, title:item.dataset.title, vendor:item.dataset.vendor}));
    }
    async bootstrap() {
      try {
        this.readCatalog(this.querySelector('[data-ac-catalog]').content);
        let next = this.querySelector('[data-ac-next]')?.dataset.acNext;
        const seen = new Set();
        while (next) {
          if (seen.has(next)) throw new Error('catalog-cycle');
          seen.add(next);
          const url = new URL(next, location.origin);
          if (url.origin !== location.origin) throw new Error('catalog-origin');
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {cache:'no-store'});
          if (!response.ok) throw new Error('catalog-status');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const template = doc.querySelector('[data-ac-catalog]');
          if (!template) throw new Error('catalog-missing');
          this.readCatalog(template.content);
          next = doc.querySelector('[data-ac-next]')?.dataset.acNext;
        }
        const query = new URLSearchParams(location.search);
        const count = query.has('p3') ? 3 : 2;
        for (let index = 0; index < count; index++) this.addSlot();
        await Promise.all(this.slots.map((slot, index) => {
          const handle = query.get(`p${index + 1}`);
          return handle ? this.selectProduct(slot, handle, query.get(`v${index + 1}`)) : null;
        }));
        this.notice.textContent = '';
        this.stamp = Date.now();
        this.initialized = true;
        this.querySelector('[data-example]').disabled = false;
        this.sync();
      } catch (_) { this.notice.textContent = this.t('catalog_error'); this.notice.classList.add('ac-error'); }
    }
    addSlot() {
      if (this.slots.length >= 3) return;
      const slot = {handle:'', product:null, variant:null, token:0};
      const card = this.el('article', 'ac-slot');
      const top = this.el('div', 'ac-slot-top');
      slot.number = this.el('span', 'slot-number');
      slot.remove = this.el('button', 'ac-remove', this.t('remove'));
      slot.remove.type = 'button';
      slot.remove.addEventListener('click', () => {
        slot.token++;
        if (this.slots.length > 2) { this.slots = this.slots.filter(item => item !== slot); card.remove(); }
        else { slot.handle = ''; slot.product = null; slot.variant = null; slot.select.value = ''; slot.search.value = ''; this.options(slot); slot.content.replaceChildren(this.el('p','ac-empty',this.t('empty'))); }
        this.sync();
      });
      top.append(slot.number, slot.remove);
      const searchLabel = this.el('label', '', this.t('search'));
      slot.search = this.el('input'); slot.search.type = 'search'; slot.search.placeholder = this.t('search_placeholder'); slot.search.autocomplete = 'off';
      searchLabel.append(slot.search);
      slot.search.addEventListener('input', () => this.options(slot));
      const modelLabel = this.el('label','',this.t('model'));
      slot.select = this.el('select');
      slot.select.addEventListener('change', () => this.selectProduct(slot, slot.select.value));
      modelLabel.append(slot.select);
      slot.content = this.el('div','ac-slot-content');
      slot.content.append(this.el('p','ac-empty',this.t('empty')));
      card.append(top, searchLabel, modelLabel, slot.content);
      slot.card = card;
      this.slots.push(slot);
      this.options(slot);
      this.container.append(card);
      this.renumber();
      return slot;
    }
    options(slot) {
      const fold = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const query = fold(slot.search.value.trim());
      const placeholder = this.el('option','', this.t('choose')); placeholder.value = '';
      slot.select.replaceChildren(placeholder);
      const entries = [...this.catalog.values()].sort((a,b) => this.name(a).localeCompare(this.name(b)));
      entries.filter(product => product.handle === slot.handle || fold(this.name(product)).includes(query)).forEach(product => {
        const option = this.el('option','',this.name(product)); option.value = product.handle; slot.select.append(option);
      });
      slot.select.value = slot.handle;
    }
    renumber() {
      this.style.setProperty('--ac-count', String(this.slots.length));
      this.slots.forEach((slot,index) => {slot.number.textContent = `${this.t('model')} ${index + 1}`; slot.remove.setAttribute('aria-label', `${this.t('remove')} ${this.t('model')} ${index + 1}`);});
      this.addButton.disabled = !this.initialized || this.slots.length >= 3;
    }
    async fetchProduct(handle) {
      if (!this.catalog.has(handle)) throw new Error('unavailable');
      const url = `${this.rootPath}products/${encodeURIComponent(handle)}.js`;
      const response = await fetch(url, {cache:'no-store', headers:{Accept:'application/json'}});
      if (response.status === 404) throw new Error('unavailable');
      if (!response.ok) throw new Error('network');
      const product = await response.json();
      if (product.handle !== handle || !Array.isArray(product.variants)) throw new Error('network');
      if (product.variants.length >= 250) throw new Error('too-many');
      return product;
    }
    async selectProduct(slot, handle, variantId) {
      const ticket = ++slot.token;
      slot.handle = handle; slot.product = null; slot.variant = null; slot.requestedVariant = variantId || '';
      slot.content.replaceChildren(this.el('p','ac-status',this.t('loading')));
      this.sync();
      if (!handle) {slot.content.replaceChildren(this.el('p','ac-empty',this.t('empty')));return;}
      try {
        const product = await this.fetchProduct(handle);
        if (slot.token !== ticket || !this.slots.includes(slot)) return;
        slot.product = product;
        const requested = variantId ? product.variants.find(variant => String(variant.id) === String(variantId)) : null;
        slot.variant = variantId ? (requested?.available ? requested : null) : product.variants.find(variant => variant.available) || null;
        slot.missing = Boolean(variantId && !slot.variant);
        this.renderProduct(slot);
      } catch (error) {
        if (slot.token !== ticket || !this.slots.includes(slot)) return;
        slot.product = null; slot.variant = null; slot.specs = null;
        slot.content.replaceChildren(this.el('p','ac-error',this.t(error.message === 'unavailable' ? 'unavailable_product' : 'load_error')));
        const retry = this.el('button','ac-button secondary',this.t('retry')); retry.type = 'button';
        retry.addEventListener('click', () => this.selectProduct(slot,handle,variantId));slot.content.append(retry);
      }
      this.sync();
    }
    renderProduct(slot) {
      const product = slot.product;
      const variant = slot.variant;
      slot.content.replaceChildren();
      const image = this.el('img','ac-product-photo');
      let src = variant?.featured_image?.src || product.featured_image;
      if (src) {
        try { const url = new URL(src, location.origin); if (url.protocol === 'https:' || url.origin === location.origin) {url.searchParams.set('width','440');image.src = url.href; image.alt = this.name(product); image.width = 220; image.height = 220; image.loading = 'eager';slot.content.append(image);if(!variant?.featured_image?.src)slot.content.append(this.el('p','ac-footer-note',this.t('general_photo')));} } catch (_) {}
      }
      slot.content.append(this.el('p','ac-vendor', product.vendor), this.el('h2','',product.title));
      const variantLabel = this.el('label','',this.t('configuration'));
      const select = this.el('select','ac-variant-select');
      if (!variant) {const option = this.el('option','',this.t('choose_configuration'));option.value='';option.selected=true;select.append(option);}
      product.variants.filter(item => item.available).forEach(item => {const option = this.el('option','',`${item.title} · ${this.money(item.price)}`);option.value=String(item.id);option.selected=String(item.id)===String(variant?.id);select.append(option);});
      select.addEventListener('change', () => {
        slot.token++;slot.variant = product.variants.find(item => String(item.id) === select.value && item.available)||null;slot.missing=false;slot.requestedVariant='';
        try {this.renderProduct(slot);this.sync();slot.content.querySelector('.ac-variant-select')?.focus();}
        catch (_) {slot.variant=null;slot.specs=null;slot.content.replaceChildren(this.el('p','ac-error',this.t('load_error')));this.sync();}
      });
      variantLabel.append(select);slot.content.append(variantLabel);
      if (!variant) {slot.content.append(this.el('p','ac-error',this.t(slot.missing?'unavailable_configuration':'sold_out')));return;}
      slot.content.append(this.el('p','ac-selected-variant',variant.title), this.el('p','ac-price',this.money(variant.price)), this.el('p','ac-status',this.t('available')));
      slot.specs = parseComparisonSpecs(product,variant);
      const verified = this.overrides.products[product.handle];
      if(verified && String(verified.productId)===String(product.id)) {
        slot.specs.groups.forEach(group=>group.rows.forEach(row=> {if(verified.fields[row.key])row.value=verified.fields[row.key];}));
      }
      const config=slot.specs.configuration||{};
      const colorIndex=product.options.findIndex(option=>/color|colour/i.test(typeof option==='string'?option:option.name));
      const colors=colorIndex<0?this.t('unspecified'):[...new Set(product.variants.filter(item=>item.available&&item.options.every((value,index)=>index===colorIndex||value===variant.options[index])).map(item=>item.options[colorIndex]))].join(', ');
      slot.specs.groups.unshift({id:'configuration',rows:[
        {key:'storage',value:config.storage||this.t('unspecified')}, {key:'ram',value:config.ram||this.t('unspecified')},
        {key:'color',value:config.color||this.t('unspecified')}, {key:'available_colors',value:colors}, {key:'gift',value:config.gift||this.t('unspecified')}
      ]});
      const gift = slot.specs.configuration?.gift;
      if (gift && gift !== 'No especificado') slot.content.append(this.el('p','ac-gift',`${this.t('includes')}: ${gift}`));
      const link = this.el('a','ac-product-link',this.t('view_product'));
      link.href = `${this.rootPath}products/${encodeURIComponent(slot.handle)}?variant=${variant.id}`;
      link.addEventListener('click', async event => {
        event.preventDefault();link.setAttribute('aria-disabled','true');
        const ticket=slot.token;const handle=slot.handle;const destination=link.href;
        try {
          const current=await this.fetchProduct(handle);
          if(slot.token!==ticket||!this.slots.includes(slot)||String(slot.variant?.id)!==String(variant.id))return;
          const exact=current.variants.find(item=>String(item.id)===String(variant.id)&&item.available);
          if (!exact) {await this.selectProduct(slot,slot.handle,variant.id);return;}
          location.assign(destination);
        } catch (_) {this.notice.textContent=this.t('load_error');}
        finally {link.removeAttribute('aria-disabled');}
      });
      slot.content.append(link);
    }
    renderResults() {
      const selected = this.slots.filter(slot => slot.variant && slot.product && slot.specs);
      this.results.replaceChildren();
      if (selected.length < 2) {this.results.append(this.el('p','ac-empty',this.t('choose_two')));return;}
      this.results.style.setProperty('--ac-count',String(selected.length));
      const models = selected.map(slot => ({full:`${this.name(slot.product)} · ${slot.variant.title}`,short:`${this.slots.indexOf(slot)+1} · ${this.name(slot.product)}`}));
      const summary = this.el('section','ac-summary');
      summary.append(this.el('h2','',this.t('comparison_title')));
      this.results.append(summary);
      const groupDefinitions = selected[0].specs.groups;
      for (const definition of groupDefinitions) {
        const group = this.el('details','ac-group');group.open=true;
        const heading=this.el('summary','',this.t(`group_${definition.id}`));group.append(heading);
        const rows=this.el('div','ac-rows');
        const columnHead=this.el('div','ac-row ac-column-head');
        columnHead.append(this.el('div','ac-feature',this.t('configuration')));
        const columnValues=this.el('div','ac-values');
        models.forEach(model=>columnValues.append(this.el('div','ac-value',model.full)));
        columnHead.append(columnValues);rows.append(columnHead);
        let visible=0;
        for (const field of definition.rows) {
          const values=selected.map(slot=>slot.specs.groups.find(item=>item.id===definition.id)?.rows.find(item=>item.key===field.key)?.value||this.t('unspecified'));
          const normal=values.map(value=>String(value).trim().toLowerCase());
          if(normal.every(value=>value===this.t('unspecified').toLowerCase()))continue;
          const different=new Set(normal).size>1;
          if (this.diffInput.checked&&!different) continue;
          const row=this.el('div',`ac-row${different?' is-different':''}`);
          row.append(this.el('div','ac-feature',this.t(`field_${field.key}`)));
          const cells=this.el('div','ac-values');
          values.forEach((value,index)=> {const cell=this.el('div','ac-value');cell.append(this.el('span','ac-model-label',models[index].short),this.el('span','ac-value-text',value));cells.append(cell);});
          row.append(cells);rows.append(row);visible++;
        }
        if (visible) {group.append(rows);this.results.append(group);}
      }
      if (this.results.children.length===1) this.results.append(this.el('p','ac-empty',this.t('no_differences')));
    }
    stateUrl() {
      const url=new URL(location.pathname,location.origin);
      this.slots.forEach((slot,index)=> {if(slot.handle){url.searchParams.set(`p${index+1}`,slot.handle);if(slot.variant)url.searchParams.set(`v${index+1}`,String(slot.variant.id));else if(slot.requestedVariant)url.searchParams.set(`v${index+1}`,slot.requestedVariant);}});
      return url;
    }
    shareUrl() {
      const url=this.stateUrl();
      url.pathname=`${this.rootPath}vs`;
      return url;
    }
    sync() {
      this.renumber();this.slots.forEach(slot=>this.options(slot));this.renderResults();
      const stateUrl=this.stateUrl();
      const url=this.shareUrl();
      history.replaceState(null,'',stateUrl.pathname+stateUrl.search);
      this.shareInput.value=url.href;
      const enough=this.slots.filter(slot=>slot.variant).length>=2;
      this.querySelectorAll('[data-copy]').forEach(button=>button.disabled=!enough);
      this.querySelector('[data-example]').hidden=this.slots.some(slot=>slot.product);
      const whatsapp=this.querySelector('[data-whatsapp]');
      whatsapp.hidden=!enough;
      whatsapp.href=`https://wa.me/${this.dataset.sales}?text=${encodeURIComponent(`${this.t('whatsapp_message')} ${url.href}`)}`;
    }
    async copy() {
      try {await navigator.clipboard.writeText(this.shareUrl().href);this.notice.textContent=this.t('copied');}
      catch (_) {this.shareInput.focus();this.shareInput.select();this.notice.textContent=this.t('copy_manual');}
    }
    async refresh() {
      if (this.refreshing) return;
      this.refreshing=true;
      try {await Promise.all(this.slots.filter(slot=>slot.handle).map(slot=>this.selectProduct(slot,slot.handle,slot.variant?.id||slot.requestedVariant)));this.stamp=Date.now();}
      finally {this.refreshing=false;}
    }
    async example() {
      if (!this.initialized) return;
      const preferred=['a56','redmi-note-15-pro-5g'];
      const models=preferred.filter(handle=>this.catalog.has(handle));
      if(models.length<2) models.push(...[...this.catalog.keys()].filter(handle=>!models.includes(handle)).slice(0,2-models.length));
      await Promise.all(models.slice(0,2).map((handle,index)=>this.selectProduct(this.slots[index],handle)));
    }
  }
  if (!customElements.get('allstock-comparator')) customElements.define('allstock-comparator', AllstockComparator);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
